import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    companyNewsList: {
      info:''
    },
    companyNews: {
      info:''
    },
  },
  mutations: {
    [types.SET_COMPANY_NEWS_LIST](state, payload) {
      const info = payload.info || {}
      const data = Array.isArray(info.data) ? info.data : []

      state.companyNewsList.info = {
        ...info,
        data: data.filter(news => typeof news.title === 'string' && news.title.trim())
      }
    },
    [types.SET_COMPANY_NEWS](state, payload) {
      state.companyNews.info = payload.info
    },
  },
  actions: {
    getCompanyNewsList({dispatch, commit},$payload) {

      let url = process.env.VUE_APP_API_URL + "news/list?page="+$payload
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
      //  console.log(data)
        commit({
          type: types.SET_COMPANY_NEWS_LIST,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

    getCompanyNews({dispatch, commit},$payload) {

      let url = process.env.VUE_APP_API_URL + "news/"+$payload
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
      //  console.log(data)
        commit({
          type: types.SET_COMPANY_NEWS,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
  }
}
